<div class="flex gap-4 flex-wrap" data-id="applied-filters">
  @for (filter of filters; track filter.id) {
    <p-button
      [attr.data-id]="'applied-filter-tag-' + filter.id"
      styleClass="bd-filter-tag"
      [disabled]="true"
    >
      <div class="bd-tag-icon">
        <span data-id="bd-check-icon" class="ui-check"> </span>
      </div>

      <ng-template pTemplate="content">
        <span data-id="applied-filter-tag-label" class="bd-label-regular flex">
          @for (label of filter.label; track label.textKey ?? label.text) {
            <span class="flex items-center">
              @if (label.icon) {
                <i
                  data-id="applied-filter-tag-label-icon"
                  class="{{ label.icon }}"
                  [ngClass]="$first ? 'mr-2' : 'mx-2'"
                ></i>
              } @else if (!$first) {
                <span>&nbsp;</span>
              }

              @let text = (label | translateDisplayText: 'text' | async) ?? '';
              <span data-id="applied-filter-tag-label-text">{{ text }}</span>
              @if (!$last) {
                <span>&nbsp;|</span>
              }
            </span>
          }
        </span>
      </ng-template>
    </p-button>
  }
</div>
